<template>
  <ImageGallery
      api-endpoint="/api/hair"
      title="Hair & Wigs Gallery"
      subtitle="A collection of styles and textures."
  />
</template>

<script>
import ImageGallery from './ImageGallery.vue';

export default {
  name: 'HairGallery',
  components: {
    ImageGallery
  }
};
</script>